import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchServices } from '@/api/servicesApi';
import type { Service } from './types';
import {
  fetchServicesRequested,
  fetchServicesSucceeded,
  fetchServicesFailed,
} from './servicesSlice';

function* handleFetchServices() {
  try {
    const services: Service[] = yield call(fetchServices);
    yield put(fetchServicesSucceeded(services));
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Failed to load services';
    yield put(fetchServicesFailed(message));
  }
}

export function* servicesSaga() {
  yield takeLatest(fetchServicesRequested.type, handleFetchServices);
}
